/* site.js - baseline JS (defer-geladen)
 * - Menu/search/cart drawer toggles
 * - Hover-prefetch voor PDP-links (sectie 5.1.G)
 * - Lazy search-init op focus (sectie 5.1.F)
 * - Cart-count live update
 */
(() => {
  'use strict';

  // ---- Mobile menu toggle ----
  const menuToggle = document.querySelector('[data-menu-toggle]');
  const mobileMenu = document.getElementById('mobile-menu');
  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', () => {
      const isOpen = !mobileMenu.classList.contains('hidden');
      mobileMenu.classList.toggle('hidden');
      menuToggle.setAttribute('aria-expanded', String(!isOpen));
    });
  }

  // ---- Hover-prefetch voor PDP/collection links (sectie 5.1.G) ----
  // Pre-cache HTML van product/collection-page bij hover/focus voor snelle navigatie.
  const prefetched = new Set();
  const prefetch = (url) => {
    if (prefetched.has(url) || !url.startsWith('/') || url.startsWith('/cart')) return;
    prefetched.add(url);
    const link = document.createElement('link');
    link.rel = 'prefetch';
    link.href = url;
    link.as = 'document';
    document.head.appendChild(link);
  };
  document.addEventListener('mouseover', (e) => {
    const a = e.target.closest('a[href^="/products/"], a[href^="/collections/"]');
    if (a) prefetch(a.getAttribute('href'));
  }, { passive: true });

  // ---- Cart-count live update na /cart/add.js ----
  // Luister naar cart-changes via fetch-interception (lichtgewicht).
  const cartCountEl = document.querySelector('[data-cart-count]');
  if (cartCountEl) {
    const updateCartCount = async () => {
      try {
        const r = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
        const cart = await r.json();
        cartCountEl.textContent = cart.item_count;
      } catch (_) { /* silent */ }
    };
    document.addEventListener('cart:updated', updateCartCount);
  }
})();
